import React from 'react'

export default ({ children, className = '' }) => (
  <th className={className + ' head'}>
    {children}
  </th>
)
